import React from 'react';

interface SkeletonProps {
  className?: string;
}

/**
 * Skeleton loader component for smooth transitions
 */
export default function Skeleton({ className = '' }: SkeletonProps) {
  return (
    <div className={`animate-pulse bg-bg-control rounded ${className}`} />
  );
}
